export const OPTIONS_FREQUENCY_CAPPING = [
  { label: 'a lifetime', value: 0 },
  { label: 'a day', value: 1440 },
  { label: 'a week', value: 10080 },
  { label: 'a month', value: 43800 },
  { label: '3 month', value: 131500 }
];
